import useDepositSelectButton from './useDepositSelectButton';

export interface DepositSelectButtonProps {
  value: number;
  percentage: string;
  key: string;
  id: string;
  onClick: () => void;
}

const DepositSelectButton: React.FunctionComponent<DepositSelectButtonProps> =
  function ({ percentage, id, onClick }) {
    const { buttonClassName } = useDepositSelectButton(percentage);
    return (
      <button
        type="button"
        id={id}
        onClick={onClick}
        className={buttonClassName}
      >
        {percentage === 'custom' ? 'Custom' : percentage}
      </button>
    );
  };

export default DepositSelectButton;
